import React, { useState, useEffect } from 'react';
import { withApollo } from 'react-apollo';
import gql from 'graphql-tag';
import EmployeeDetailsComponent from './EmployeeDetailsComponent';

// Define the GraphQL query for recognition events
const QUERY_RECOGNITION_EVENTS = gql`
  query RecognitionEventsByUserId($id: String!) {
    recognitionEventsByUserId(id: $id) {
      recognitionEvents {
        currentBudget
        amountPending
        additionalBudgetTotal
        lastUpdated
        eventList {
          adminOverride
          approvalResult
          budgetAfterTotal
          budgetBeforeTotal
          completedById
          completedByUser
          completedDate
          createdDate
          pendingApproval
          recognitionAmount
          recognitionId
          recognition
          recognitionName
          sentById
          sentByUser
          sentByManager
          sentReason
          snappyCampaignTierId
          snappyCampaignTier
        }
      }
    }
  }
`;

/**
 * Wrapper component for EmployeeDetailsComponent that uses Apollo client directly
 *
 * This component uses the regular Apollo client from ApiProviderComponent
 * to fetch recognition events data and passes it to the EmployeeDetailsComponent
 */
const EmployeeDetailsWithHooks = (props) => {
  const [recognitionEvents, setRecognitionEvents] = useState({});
  const [isLoadingRecognitionEvents, setIsLoadingRecognitionEvents] = useState(false);
  const [recognitionEventsError, setRecognitionEventsError] = useState(null);

  // Function to fetch recognition events
  const fetchRecognitionEvents = async () => {
    if (!props?.id || !props?.client) return;

    setIsLoadingRecognitionEvents(true);
    setRecognitionEventsError(null);

    try {
      const { data } = await props.client.query({
        query: QUERY_RECOGNITION_EVENTS,
        variables: { id: props.id },
        fetchPolicy: 'network-only'
      });

      const events = data?.recognitionEventsByUserId?.recognitionEvents || {};
      setRecognitionEvents(events);
    } catch (e){
      // Many people might not have the recognition events yet
      setRecognitionEventsError(e);
    } finally {
      setIsLoadingRecognitionEvents(false);
    }
  };

  // Fetch recognition events when component mounts or id changes
  useEffect(() => {
    fetchRecognitionEvents();
  }, [props.id]);

  // Refetch function to be passed to child component
  const refetchRecognitionEvents = () => {
    fetchRecognitionEvents();
  };

  // Pass the recognition events data to the EmployeeDetailsComponent
  return (
    <EmployeeDetailsComponent
      {...props}
      recognitionEvents={recognitionEvents}
      isLoadingRecognitionEvents={isLoadingRecognitionEvents}
      refetchRecognitionEvents={refetchRecognitionEvents}
    />
  );
};

export default withApollo(EmployeeDetailsWithHooks);